import React from 'react'

const infoBox = props => {
  if (props.appState.item !== 6) return <div className='container-block'>
    <div className='info-box' style={{ height: props.w * props.appState.itemSize, borderBottom: '2px solid black' }}>
      <h2>{props.section.title}</h2>
      <div dangerouslySetInnerHTML={{ __html: props.section.description }} />
    </div>
    <div className='container-info' style={{ background: props.appState.colorTheme.secondary, height: props.appState.item === 2 ? props.appState.itemSize : 'auto' }}>
      <div onClick={props.onApplyFilter} style={{ cursor: 'pointer' }} className='container-data button-container'>
        <div>
          <h2>Archivo</h2>
          <p>Residencias</p>
        </div>
        <div>
          <span className="icon-search-03"></span>
        </div>
      </div>
    </div>
  </div>

  return <div className='info-box'>
    <h2>{props.section.title}</h2>
    <div dangerouslySetInnerHTML={{ __html: props.section.description }} />
  </div>
}

export default infoBox